export const FILE_TYPES = {
  pdf: {
    color: "#fe6862",
    extensions: [".pdf"],
  },
  image: {
    color: "#30bdb4",
    extensions: [".jpg", ".jpeg", ".png"],
  },
  video: {
    color: "#9bbfbb",
    extensions: [".mp4", ".avi", ".mpeg", ".mkv"],
  },
  audio: {
    color: "#fcbe69",
    extensions: [".mp3", ".wav", ".ogg", ".aac"],
  },
  zip: {
    color: "#b88466",
    extensions: [".zip"],
  },
  text: {
    color: "#70b2da",
    extensions: [".doc", ".docx", ".odt", ".txt"],
  },
  spreadsheet: {
    color: "#8bc0a2",
    extensions: [".xls", ".xlsx", ".ods"],
  },
  ANY: {
    color: "#007935",
    extensions: [
      ".pdf",
      ".jpg",
      ".jpeg",
      ".png",
      ".mp4",
      ".avi",
      ".mpeg",
      ".mkv",
      ".mp3",
      ".wav",
      ".ogg",
      ".aac",
      ".zip",
      ".doc",
      ".docx",
      ".odt",
      ".txt",
      ".xls",
      ".xlsx",
      ".ods",
    ],
  },
} as const;

const EXT_MIME_MAP: Record<string, string> = {
  ".pdf": "application/pdf",
  ".jpg": "image/jpeg",
  ".jpeg": "image/jpeg",
  ".png": "image/png",
  ".mp4": "video/mp4",
  ".avi": "video/x-msvideo",
  ".mpeg": "video/mpeg",
  ".mkv": "video/x-matroska",
  ".mp3": "audio/mpeg",
  ".wav": "audio/wav",
  ".ogg": "audio/ogg",
  ".aac": "audio/aac",
  ".zip": "application/zip",
  ".doc": "application/msword",
  ".docx":
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ".odt": "application/vnd.oasis.opendocument.text",
  ".txt": "text/plain",
  ".xls": "application/vnd.ms-excel",
  ".xlsx":
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ".ods": "application/vnd.oasis.opendocument.spreadsheet",
};

export const getMimeType = (ext: string): string | null =>
  EXT_MIME_MAP[ext.toLowerCase()] ?? null;
